/**
 * My API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface EnrichedFieldInfo { 
    nickname?: string;
    variable_id?: string;
    original_unit?: string;
    custom_unit?: string;
    latest_value?: number;
}

